import {target} from '../utils/dom';

document.addEventListener('layoutOpen', onLayout);
document.addEventListener('layoutClose', onLayout);

function onLayout(event) {
	const mosaic = target(event.target, '.js-slx-mosaic');
	if (!mosaic) {
		return;
	}
	const action = event.type === 'layoutOpen' ? 'add' : 'remove';
	mosaic.classList[action]('active');
}
